export default "__VITE_ASSET__CSSmU9Kd__"